import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { ReduxAlert } from "../../containers";
import { GenericForm } from "../../components";
import { Link } from "react-router-dom";

// import { authActions } from '../../_actions';

import { authCreators } from "../../_creators";
import loginForm from "./login-form";

import "./login.css";
class LoginPage extends Component {
	constructor(props) {
		super(props);
		this.props.logout();

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleBlur = this.handleBlur.bind(this);

		this.state = {
			form: {
				values: loginForm.defaultValues,
				errors: {},
				error: false,
				loading: false,
			},
		};
	}

	handleChange(group, input, value) {
		this.setState((state) => {
			let form = { ...state.form };
			if (input == "email") value = value.toLowerCase();
			form.values = GenericForm.updateGroups(form.values, {
				group,
				input,
				value: value.trim(),
			});
			return { form };
		});
	}

	handleBlur(group, input, value) {}
	handleSubmit(e) {
		e.preventDefault();

		let { errors, error } = GenericForm.validateForm(
			this.state.form.values,
			loginForm.validators
		);

		if (errors && Object.keys(errors).length > 0)
			this.setState(({ form }) => ({
				form: { ...form, errors, error },
			}));
		else {
			e.preventDefault();
			this.props.login(
				GenericForm.extractValues(
					{ groups: this.state.form.values },
					loginForm.extractors
				)
			);
		}
	}
	render() {
		let stateForm = this.state.form;
		return (
			<div className="form-signin">
				<h1 className="h3 mb-3 font-weight-normal">
					Connecter vous SVP
				</h1>
				<ReduxAlert />
				<GenericForm
					groups={loginForm.groups}
					defaultValues={loginForm.defaultValues}
					values={stateForm.values}
					errors={stateForm.errors}
					onChange={this.handleChange}
					onBlur={this.handleBlur}
					onSubmit={this.handleSubmit}
					submit={{
						title: "Se Connecter",
						className: "btn btn-primary btn-block",
						disabled: this.props.auth.loggingIn,
					}}
				/>
				<Link
					to="/reset"
					className="nav-link"
					style={{
						padding: "15px 0px",
						width: "fit-content",
						margin: "auto",
					}}
				>
					Mot de passe oublié?
				</Link>
				<small className="mt-5 mb-3 text-muted">
					Attention: en vous connectant, vous accepter les{" "}
					<a
						target="_blank"
						href="https://www.corneliacontactalgerie.com/"
					>
						Condition d'utilisation
					</a>
				</small>
				<p className="mt-5 mb-3 text-muted text-center">
					&copy; Cornelia Contact Algeria 2020 | Designed
					and Developed by{" "}
					<a
						target="_blank"
						href="http://elbeytechnologies.com/"
					>
						ELBEY Technologies
					</a>
				</p>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({ auth: state.auth });
const mapDispatchToProps = (dispatch) => ({
	login: (user) => authCreators.login(user)(dispatch),
	logout: () => authCreators.logout()(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
